<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        src="img/user_icon.jpg"
        class="img-avatar"
        alt="account" />
    </template>\
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>{{name}}</strong></b-dropdown-header>
      <b-dropdown-divider />
      <b-dropdown-item @click="logout()"><i class="fa fa-lock"/> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import router from '../router'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 }
  },
  computed: {
    name() {
      return JSON.parse(atob(window.localStorage.getItem('token').split('.')[1])).user.Name
    }
  },
  methods: {
    logout: function() {
      window.localStorage.clear()
      router.push('/login')
    }
  }
}
</script>
